import React from 'react'

function NotFound() {
    return (
        <div>
            <h1>404 - Sayfa Bulunamadı</h1>
        </div>
    )
}

export default NotFound
